import { User, UserRole, UserType } from '@wam/shared';
import { isReportsApp } from '@app/reports-app/reports-app.util';

const userByLocation = {
  teacher: UserType.TEACHER,
  admin: UserType.ADMIN,
};

export function determineUserType(url = window.location.href): UserType {
  url = url.split('?')[0];
  let type: UserType;
  Object.keys(userByLocation).forEach((key: string) => {
    if (RegExp(`${key}\\\.`).test(url)) {
      type = userByLocation[key];
    }
  });
  // The standalone reports app is backed by the teacher application. It is detected by host
  // (`reports.waterford.org` and friends) rather than by a marker in the URL, so that a path
  // or query param can never flip the teacher/admin apps into it.
  if (!type && isReportsApp()) {
    // @ts-ignore
    type = UserType.TEACHER;
  }

  // @ts-ignore
  localStorage.setItem('userType', type);
  // @ts-ignore
  return type || UserType.UNKNOWN;
}

export function getFromLocalStorage(): User | null {
  try {
    const currentUser = localStorage.getItem('currentUser');
    return currentUser && JSON.parse(currentUser);
  } catch {
    return null;
  }
}

export function isStaff(user?: User | UserType): boolean {
  if (typeof user === 'string') {
    return user === UserType.TEACHER;
  }
  return user?.type === UserType.TEACHER;
}

export function isInternalAdminOrAccountAdminOrSupportEngineer(
  userType: UserType,
  userRoles: UserRole[],
): boolean {
  return (
    userType === UserType.ADMIN &&
    (userRoles?.includes(UserRole.INTERNAL_ADMIN) ||
      userRoles?.includes(UserRole.ACCOUNT_ADMIN) ||
      userRoles?.includes(UserRole.SUPPORT_ENGINEER))
  );
}
